import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

export interface ListItemProps {
  bottomElement?: React.ReactNode;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  subtitle?: string | React.ReactNode;
  title: string | React.ReactNode;
}

export const ListItem: React.FC<ListItemProps> = ({
  bottomElement,
  leftElement,
  style,
  rightElement,
  subtitle,
  title,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={[styles.container, style]}>
      {leftElement ? <View style={styles.left}>{leftElement}</View> : null}
      <View style={bottomElement ? styles.contentWithBottom : styles.content}>
        {typeof title === 'string' ? (
          <Typography numberOfLines={1} variant="paragraph-base-600">
            {title}
          </Typography>
        ) : (
          title
        )}
        {subtitle && typeof subtitle === 'string' ? (
          <Typography
            color={theme.sk.color.text.tertiary}
            numberOfLines={1}
            variant="paragraph-md"
          >
            {subtitle}
          </Typography>
        ) : subtitle ? (
          subtitle
        ) : null}
        {bottomElement ? (
          <View style={styles.bottom}>{bottomElement}</View>
        ) : null}
      </View>
      {rightElement ? rightElement : null}
    </View>
  );
};

const useStyles = createStyles(() => ({
  bottom: {
    marginTop: 4,
  },
  container: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: 12,
  },
  content: {
    flex: 1,
  },
  contentWithBottom: {
    flex: 1,
    justifyContent: 'space-between',
  },
  left: {
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
